/**
 * This file will contain all the util functions related to Staggered Price.
 * */

import { UEListData } from "@/app/interface/homepage";

export type Price = {
    priceStepSize: number;
    unitPrice: number;
};

const roundToNearestStepSize = (amount: number, stepSize: number = 0.1): number => {
    if (!amount || !stepSize) {
        return amount;
    }
    return +(Math.round(amount / stepSize) * stepSize).toFixed(4);
};

export const updateStaggerdPrice = (staggeredPrice: UEListData["staggeredPrice"], price: Price) => {
    staggeredPrice.forEach((ladder) => {
        const forthValue = roundToNearestStepSize(
            +(price.unitPrice - price.unitPrice * ladder[2]),
            price.priceStepSize,
        );
        ladder.push(forthValue);
    });
};

export function getStaggeredDataMinPrice(staggeredPrice: UEListData["staggeredPrice"]): number {
    const lastArr: number[] = staggeredPrice[staggeredPrice?.length - 1];
    const value = lastArr[lastArr?.length - 1];
    return value;
}

export function lowercaseSplitJoin(
    str: string,
    splitChar: string = " ",
    joinChar: string = "-",
): string {
    return str.toLowerCase().split(splitChar).join(joinChar);
}

export const sanitizeText = (text: string): string => {
    return text
        ?.toLowerCase()
        ?.replace(/[\u2018\u2019\u201A\u201B\u2039\u203A]/g, "'") // normalize curly apostrophes to '
        ?.replace(/[\u201C\u201D\u201E\u201F\u00AB\u00BB]/g, '"') // normalize curly quotes to "
        ?.replace(/[\u2013\u2014\u2015]/g, "-") // normalize dashes to hyphen
        ?.replace(/\s+/g, " ") // normalize multiple spaces
        ?.trim();
};
